import { render, staticRenderFns } from "./OwnersAssociations.vue?vue&type=template&id=0c285e66&"
import script from "./OwnersAssociations.vue?vue&type=script&lang=js&"
export * from "./OwnersAssociations.vue?vue&type=script&lang=js&"
import style0 from "./OwnersAssociations.vue?vue&type=style&index=0&id=0c285e66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports